module.exports = __webpack_public_path__ + "ff0f0e762299f4adf908b788a0172c05.woff2";